import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchBodyShape, createBodyShape, deleteBodyShape, updateBodyShape, fetchCategory, updateBodyShapeDisabled } from '../../common/jsonstore';
import { BodyShape } from '../../common/model';
import { AppState } from '../../redux/store/rootReducer';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { signOut } from '../../services/localStorage';
import { handleError } from '../../services/messageApiService';


export interface IAuthentication {
  BodyShapeArr: BodyShape[];
  success: any;
  isProcessingComplete: boolean;
}

const initialState: IAuthentication = { BodyShapeArr: [], success: {}, isProcessingComplete: false };

// const initialState: BodyShape[] = [];

const BodyShapeSlice = createSlice({
  name: 'BodyShape',
  initialState,
  reducers: {
    receiveUsers(state, action: PayloadAction<BodyShape[]>) {
      // return action.payload;
      return {
        ...state,
        BodyShapeArr: action.payload,
        isProcessingComplete: false
      };
    },
    receiveUser(state, action: PayloadAction<any>) {
      // state.push(action.payload);
      return {
        ...state,
        BodyShapeArr: action.payload,
        isProcessingComplete: false
      };
    },
    success: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        success: action.payload,
        isProcessingComplete: true
      };
    }
  }
});


export const loadBodyShape = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const BodyShape = await fetchBodyShape().then((resp: any) => {
      dispatch(BodyShapeSlice.actions.receiveUsers(resp));
    }).catch((err: any) => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Body Shape data not loaded';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const addBodyShape = (newCat: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res: any = await createBodyShape(newCat).then((resp: any) => {
      // dispatch(BodyShapeSlice.actions.receiveUser([...getState().BodyShape.BodyShapeArr, resp?.data]));
      dispatch(BodyShapeSlice.actions.receiveUsers(resp?.data));
      dispatch(BodyShapeSlice.actions.success({ 'sts': true, data: resp?.msg }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Body Shape data not added';
        dispatch(BodyShapeSlice.actions.success({ 'sts': false, msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
  // dispatch(BodyShapeSlice.actions.receiveUser(res?.data));
}

export const modifyBodyShape = (newCat: any, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res: any = await updateBodyShape(newCat, id).then((resp: any) => {
      // const updatedUsers = getState().BodyShape.BodyShapeArr.map(el => (el.id === id ? resp?.data : el))
      // dispatch(BodyShapeSlice.actions.receiveUsers(updatedUsers));
      dispatch(BodyShapeSlice.actions.receiveUsers(resp?.data));
      dispatch(BodyShapeSlice.actions.success({ 'sts': true, data: 'Body Shape updated successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Body Shape not updated';
        dispatch(BodyShapeSlice.actions.success({ 'sts': false, msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const modifyBodyShapeDisabled = (newCat: any, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res: any = await updateBodyShapeDisabled(newCat, id).then((resp: any) => {
      // const updatedUsers = getState().Category.CategoryArr.map(el => (el.id === id ? resp?.data : el))
      // dispatch(CategorySlice.actions.receiveUsers(updatedUsers));
      dispatch(BodyShapeSlice.actions.receiveUsers(resp?.data));
      dispatch(BodyShapeSlice.actions.success({ 'sts': true, data: 'Body Shape updated successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Body Shape Not Updated';
        dispatch(BodyShapeSlice.actions.success({ 'sts': false, msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const removeBodyShape = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    deleteBodyShape(id).then((res: any) => {
      // const updatedUsers = getState().BodyShape.BodyShapeArr.filter((item) => item.id !== id);
      // dispatch(BodyShapeSlice.actions.receiveUsers(updatedUsers));
      dispatch(BodyShapeSlice.actions.receiveUsers(res?.data));
      dispatch(BodyShapeSlice.actions.success({ 'sts': true, data: 'Body Shape deleted successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Body Shape not deleted';
        dispatch(BodyShapeSlice.actions.success({ 'sts': false, msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }

}

export const updateSts = (data: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  dispatch(BodyShapeSlice.actions.success(data));
}


export default BodyShapeSlice.reducer;
